import { render, staticRenderFns } from "./VerifiedAssessmentImport.vue?vue&type=template&id=0846a4cd&scoped=true&"
import script from "./VerifiedAssessmentImport.vue?vue&type=script&lang=ts&"
export * from "./VerifiedAssessmentImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846a4cd",
  null
  
)

export default component.exports